// A strong one-time initial password for a newly created account. The holder
// changes it (or enrols a passkey) on first login, so this only has to survive
// the hand-off; it is generated in the browser and never typed by the operator.
const generatePassword = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#%^&*";
    const bytes = new Uint32Array(20);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => chars[b % chars.length]).join("");
};

export default generatePassword;
